<template>
  <div>
    <h4 class="text-success">
      {{ "device_in_control" | setText("Устройство на контроле") }}
    </h4>
    <h5>{{ "go_next" | setText("Вы можете продолжить оформление") }}</h5>
  </div>
</template>
<script>
import { logger, errorNotify, toFormData } from "@/plugins/functions";

export default {
  methods: {},
  data: () => ({
    cartificate: null,
  }),
  props: ["value", "data"],
};
</script>
<style>
</style>
 